import { injectTranslate } from '@core/i18n-legacy';
import type { ProficiencyTierId } from '@core/tellent-skills-types';

export const injectProficiencyTierLabels = (): Record<ProficiencyTierId, string> => {
  const t = injectTranslate();
  return {
    novice: t('tlc.positions.skills_ideate_flow.options.proficiency.tier.novice'),
    beginner: t('tlc.positions.skills_ideate_flow.options.proficiency.tier.beginner'),
    competent: t('tlc.positions.skills_ideate_flow.options.proficiency.tier.competent'),
    proficient: t('tlc.positions.skills_ideate_flow.options.proficiency.tier.proficient'),
    advanced: t('tlc.positions.skills_ideate_flow.options.proficiency.tier.advanced'),
    expert: t('tlc.positions.skills_ideate_flow.options.proficiency.tier.expert'),
  };
};
